import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { Button, Modal } from 'react-bootstrap';
import moment from 'moment';
import DurationFormatter from '../utils/duration';
import userTaskActions from '../actions/userTaskActionCreators';
import taskActions from '../actions/taskActionCreators';
import { sortUsersByName3 } from '../utils/sorting';
import { quotaValidation } from '../constants';

import AutoUserInput from './AutoUserInput';
import UserPill from './UserPill';

require.ensure([], () => {
    require('./PMOProjectListWidget.less');
});

class EditTaskWidget extends React.Component {

    constructor(props, context) {
        super(props, context);

        //if the user is not a PM of this project, he cannot edit the task approver
        let readOnly = true;
        if (this.props.currentUser.roles.includes("PMO"))
                readOnly = false;
        if (this.props.currentUser.roles.includes("PM")) {
            if (this.props.project.manager.id === this.props.currentUser.id)
                readOnly = false;
            if (this.props.project.coManager1 && this.props.project.coManager1.id === this.props.currentUser.id)
                readOnly = false;
            if (this.props.project.coManager2 && this.props.project.coManager2.id === this.props.currentUser.id)
                readOnly = false;
        }

        this.state = {
            approver: this.props.approver,
            approverName: this.props.approverName,
            currentQuota: this.props.billable ? 0 : 40,
            description: this.props.description,
            editingOldQuotas: [],
            editingNewQuotas: [],
            taskId: this.props.taskId,
            name: this.props.name,
            newlyAssigned: [],
            noChanges: true,
            privateDescription: this.props.privateDescription,
            quotasToChange: [],
            readOnly: readOnly,
            taskQuota: this.props.taskQuota / 60,
            taskQuotaChanged: false,
            toRemove: [],
            usersAssigned: this.props.usersAssigned,
            userTasksAssigned: this.props.userTasksAssigned,
            userTasksUnassigned: [],
            usersNoLongerAssigned: this.props.usersNoLongerAssigned,
            billable: this.props.billable,
            projectType: this.props.project.type
        };

    }

    // LIFECYCLE METHODS

    componentWillReceiveProps = (nextProps) => {
        this.setState({
            approverName: this.props.approverName,
            description: this.props.description,
            name: this.props.name,
            privateDescription: this.props.privateDescription,
            taskQuota: this.props.taskQuota / 60,
            usersAssigned: this.props.usersAssigned,
            userTasksAssigned: nextProps.userTasksAssigned,
            usersNoLongerAssigned: nextProps.usersNoLongerAssigned,
        });
    }

    // EVENT HANDLERS

    handleAddUser = () => {
        let user = this.state.currentUser;

        if (user != null) {
            user.quota = this.state.currentQuota * 60;
            if (!this.containsUser(user)) {
                user.quota = this.state.currentQuota * 60;
                user.assignedOn = moment().format("YYYY-MM-DD");
                this.state.newlyAssigned.push(user);
                this.setState({
                    currentUser: null,
                    currentQuota: this.state.billable ? 0 : 40,
                    noChanges: false
               });
            }
        }
    }

    handleApproverClick = (payload) => {
        this.setState({
            approver: payload,
            noChanges: false
        });
    }

    handleApproverTextChange = () => {
        this.setState({
            approver: null,
            noChanges: false
        });
    }

    handleClick = () => {
        this.props.dispatch(taskActions.isDeletable(this.props.taskEditing.id));
        this.props.handleClick(this.props.taskEditing);
    }

    handleClose = () => {
        this.props.handleClose(this.props.taskEditing.id);
        this.handleClick();
    }

    handleConfirmedDelete = () => {
        this.props.handleDelete(this.props.taskEditing);
        this.props.handleClick(this.props.taskEditing);
        this.hideModalDialog();
    }

    handleDeleteTask = () => { this.setState({ showDeleteModal: true }); }

    handleDescriptionChange = (event) => {
        this.setState({
            description: event.target.value,
            noChanges: false
        });
    }

    handleNameChange = (event) => {
        let name = event.target.value.trim();

        this.setState({
            name: event.target.value,
            nameError: name === '' || this._taskExists(name) ? true : false,
            noChanges: false
        });
    }

    handleNewQuotaChange = (quota, key) => {
        let newlyAssigned = this.state.newlyAssigned;
        let editingNewQuotas = this.state.editingNewQuotas;
        let noChanges = this.state.noChanges;

        newlyAssigned[key].quota = quota * 60;
        editingNewQuotas[key] = false;
        noChanges = false;

        this.setState({
            editingNewQuotas,
            newlyAssigned,
            noChanges
        });
    }

    handleNewQuotaClick = (key) => {
        let editingNewQuotas = this.state.editingNewQuotas;

        for (let i = 0; i < this.state.editingNewQuotas.length; ++i) {
            editingNewQuotas[i] = false;
        }

        editingNewQuotas[key] = true;
        this.setState({ editingNewQuotas });
    }

    handleOldQuotaChange = (quota, key) => {
        let quotasToChange = this.state.quotasToChange;
        let userTasksAssigned = this.state.userTasksAssigned;
        let editingOldQuotas = this.state.editingOldQuotas;
        let noChanges = this.state.noChanges;

        quotasToChange.push({
            userTask: this.state.userTasksAssigned[key],
            quota: quota
        });

        userTasksAssigned[key].quota = quota * 60;
        editingOldQuotas[key] = false;
        noChanges = false;

        this.setState({
            editingOldQuotas,
            noChanges,
            quotasToChange,
            userTasksAssigned
        });
    }

    handleOldQuotaClick = (key) => {
        let editingOldQuotas = this.state.editingOldQuotas;

        for (let i = 0; i < this.state.editingOldQuotas.length; ++i) {
            editingOldQuotas[i] = false;
        }

        editingOldQuotas[key] = true;

        this.setState({ editingOldQuotas });
    }

    handlePrivateDescriptionChange = (event) => {
        this.setState({
            privateDescription: event.target.value,
            noChanges: false
        });
    }

    handleTaskQuotaChange = (event) => {
        this.setState({
            taskQuotaChanged: true,
            taskQuota: event.target.value,
            noChanges: false
        });
    }

    handleUserQuotaChange = (event) => {
        this.setState({
            currentQuota: event.target.value,
            noChanges: false
        },
        this.validateNewUser);
    }

    handleBillableChange = (event) => {
      this.setState({
        billable: !this.state.billable,
        noChanges: false
      });
    };


  handleRemoveNewUser = (id) => {
        let usersNoLongerAssigned = this.state.usersNoLongerAssigned;
        let newlyAssigned = this.state.newlyAssigned;
        let editingNewQuotas = this.state.editingNewQuotas;

        if(this.state.newlyAssigned[id].regularTimeSpent > 0 || this.state.newlyAssigned[id].overtimeTimeSpent > 0) {
            usersNoLongerAssigned.push(this.state.newlyAssigned[id]);
        }

        newlyAssigned.splice(id, 1);
        editingNewQuotas.splice(id, 1);

        this.setState({
            usersNoLongerAssigned,
            newlyAssigned,
            editingNewQuotas
        });
    }

    handleRemoveUser = (id) => {
        let userID = this.state.userTasksAssigned[id].userID;

        let toRemove = this.state.toRemove;
        let usersNoLongerAssigned = this.state.usersNoLongerAssigned;
        let userTasksUnassigned = this.state.userTasksUnassigned;
        let userTasksAssigned = this.state.userTasksAssigned;
        let editingOldQuotas = this.state.editingOldQuotas;
        let noChanges = this.state.noChanges;

        toRemove.push(userID);

        for(let i = 0; i < this.props.allUsers.length; i++) {
            if(this.props.allUsers[i].id === userID) {
                this.props.allUsers[i].regularTimeSpent = this.state.userTasksAssigned[id].regularTimeSpent;
                this.props.allUsers[i].overtimeTimeSpent = this.state.userTasksAssigned[id].overtimeTimeSpent;
                usersNoLongerAssigned.push(this.props.allUsers[i]);
            }
        }

        userTasksUnassigned.push(this.state.userTasksAssigned[id]);

        userTasksAssigned.splice(id, 1);
        editingOldQuotas.splice(id, 1);
        usersNoLongerAssigned.sort(sortUsersByName3);
        noChanges = false;

        this.setState({
            toRemove,
            usersNoLongerAssigned,
            userTasksUnassigned,
            userTasksAssigned,
            editingOldQuotas,
            noChanges
        });
    }

    handleReassignUser = (user) => {
        this.setState({
            currentUser: user,
            noChanges: false
        },
        this.validateNewUser);
        user.quota = 0;
        user.assignedOn = moment().format("YYYY-MM-DD");

        let newlyAssigned = this.state.newlyAssigned;
        let usersNoLongerAssigned = this.state.usersNoLongerAssigned;

        newlyAssigned.push(user);

        for (let i = 0; i < this.state.usersNoLongerAssigned.length; ++i) {
            if (this.state.usersNoLongerAssigned[i].id === user.id) {
                usersNoLongerAssigned.splice(i, 1);
                break;
            }
        }
        this.setState({
            newlyAssigned,
            usersNoLongerAssigned
        });
    }

    handleReopen = () => {
        this.props.handleReopen(this.props.taskEditing.id);
        this.handleClick(this.props.taskEditing);
    }

    handleSaveTask = () => {
        let task = {
            approver: this.state.approver,
            closed: false,
            description: this.state.description,
            name: this.state.name,
            privateDescription: this.state.privateDescription,
            parentID: this.props.project.id,
            taskQuota: this.state.taskQuota * 60,
            billable: this.state.billable
        };

        this.validate();

        if (this.state.noChanges) return;

        if (this.state.nameError) return;

        let quotasNotValidated = 0;

        for (let i = 0; i < this.state.editingOldQuotas.length; ++i) {
            if (this.state.editingOldQuotas[i]) {
                ++quotasNotValidated;
            }
        }

        for (let i = 0; i < this.state.editingNewQuotas.length; ++i) {
            if (this.state.editingNewQuotas[i]) {
                ++quotasNotValidated;
            }
        }

        if (quotasNotValidated !== 0) return;

        for (let i = 0; i < this.state.quotasToChange.length; i++) {
            this.props.dispatch(userTaskActions.updateQuota(this.state.quotasToChange[i].userTask.id, this.state.quotasToChange[i].userTask));
        }

        if (this.state.toRemove.length > 0 ) {
            this.props.handleUnassign(this.props.taskEditing, this.state.userTasksUnassigned);
        }
        if (this.state.newlyAssigned.length > 0) {
            this.props.handleAssign(this.props.taskEditing, this.state.newlyAssigned);
        }
        this.props.handleSave(this.props.taskEditing.id, task);

        this.setState({
            newlyAssigned: [],
            quotasToChange: [],
            userTasksUnassigned: []
        });

        //differently handling editing existing and saving new tasks, see handleEditTask in ProjectDetails
        if(this.props.taskEditing) {
            this.handleClick(this.props.taskEditing);
        }
        else {
            this.handleClick();
        }
    }

    handleUserSelected = (payload) => {
        let user = {
            username: payload.username,
            givenName: payload.givenName,
            surname: payload.surname,
            id: payload.id,
            quota: 0,
            active: payload.active
        };

        this.setState({
            currentUser: user
        }, this.validateNewUser);
    }

    handleUserTextChange = () => {
        let user = {
            username: "",
            givenName: "",
            surname: "",
            id: null,
            quota: 0
        };

        this.setState({
            currentUser: user
        }, this.validateNewUser);
    }

    // OTHER METHODS

    _taskExists = (name) => {
        let searchElement = name.toLowerCase().trim();
        for (let i = 0; i < this.props.taskNames.length; i++) {
            if (this.props.taskNames[i].trim() === searchElement && this.props.taskEditing.name.toLowerCase() !== this.props.taskNames[i]) {
                return true;
            }
        }

        return false;
    }

    containsUser = (user) => {
        for (let i = 0; i < this.state.userTasksAssigned.length; i++) {
            if (this.state.userTasksAssigned[i].userID === user.id)
                return true;
        }
        for (let i = 0; i < this.state.newlyAssigned.length; i++) {
            if (this.state.newlyAssigned[i].username === user.username)
                return true;
        }
        return false;
    }

    hideModalDialog = () => { this.setState({ showDeleteModal: false }); }

    validate = () => {
        this.state.nameError = this.state.name.trim() === '' || this._taskExists(this.state.name);
        this.forceUpdate();
    }

    validateNewUser = () => {
        this.setState({
            quotaError: !quotaValidation.test(this.state.currentQuota),
            newUserError: this.props.currentUser === null || this.props.currentUser.id === null
        });
    }

    // RENDER METHOD

    render = () => {
        let modal = (
            <Modal show={true} title={"Confirm task deletion"} onRequestHide={this.hideModalDialog}>
                <div className="modal-body">
                    Are you sure you want to delete task {this.props.taskEditing ? this.props.taskEditing.name : ""} ?
                </div>
                <div className="modal-footer">
                    <Button onClick={this.handleConfirmedDelete}>Yes</Button>
                    <Button onClick={this.hideModalDialog}>No</Button>
                </div>
            </Modal>
        );

        let bannedUserIDs = [];

        let totalQuota = 0;
        let totalOvertimeTimeSpent = 0;
        let totalRegularTimeSpent = 0;

        for (let i = 0; i < this.state.userTasksAssigned.length; i++) {
            if (this.state.userTasksAssigned[i]) {
                //if (this.state.userTasksAssigned[i].id === this.props.taskEditing.id) {
                    bannedUserIDs.push(this.state.userTasksAssigned[i].userID);
                    totalQuota += this.state.userTasksAssigned[i].quota;
                    totalOvertimeTimeSpent += this.state.userTasksAssigned[i].overtimeTimeSpent;
                    totalRegularTimeSpent += this.state.userTasksAssigned[i].regularTimeSpent;
                //}
            }
        }

        for (let i = 0; i < this.state.newlyAssigned.length; i++) {
            if (this.state.newlyAssigned[i]) {
                bannedUserIDs.push(this.state.newlyAssigned[i].id);
                this.state.newlyAssigned[i].quota ? totalQuota += this.state.newlyAssigned[i].quota : totalQuota += 0;
                this.state.newlyAssigned[i].overtimeTimeSpent ? totalOvertimeTimeSpent += this.state.newlyAssigned[i].overtimeTimeSpent : totalOvertimeTimeSpent += 0;
                this.state.newlyAssigned[i].regularTimeSpent ? totalRegularTimeSpent += this.state.newlyAssigned[i].regularTimeSpent : totalRegularTimeSpent += 0;
            }
        }
        for (let i = 0; i < this.state.usersNoLongerAssigned.length; i++) {
            if(this.state.usersNoLongerAssigned[i]) {
                totalOvertimeTimeSpent += this.state.usersNoLongerAssigned[i].overtimeTimeSpent;
                totalRegularTimeSpent += this.state.usersNoLongerAssigned[i].regularTimeSpent;
            }
        }

        if (this.props.active) {
            return (
                <div className="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
                    {
                        this.state.showDeleteModal ? modal : null
                    }
                    <div className="form-horizontal">
                    <div className="panel panel-default panel-pmtask">
                        <div className="panel-heading" role="tab" id="headingOne">
                            <h4 style={{wordWrap : "break-word"}} className="panel-title">
                            <a onClick={this.handleClick} style={{"cursor" : "pointer"}} data-toggle="collapse" data-parent="#accordion" aria-expanded="true" aria-controls="collapseOne">
                                <span className="md-expand-more" style={{textTransform: "none"}}/>
                                {
                                    this.props.taskEditing.closed ? <s style={{textTransform: "none"}}>{this.props.name}</s> : <span style={{textTransform: "none"}}>{this.props.name}</span>
                                }
                            </a>
                            </h4>
                        </div>
                        <div id="collapseOne" className="panel-collapse" role="tabpanel" aria-labelledby="headingOne">
                            <div className="panel-body">
                              <div className="form-group">
                                <label className="col-sm-4 control-label">Task ID:</label>
                                <div className="col-sm-8">
                                  <p className="form-control-static">{this.state.taskId}</p>
                                </div>
                              </div>
                                <div className="form-group">
                                    <label htmlFor="task_name" className="col-sm-4 control-label">Task Name:</label>
                                    <div className={this.state.nameError ? "col-sm-8 has-error" : "col-sm-8"}>
                                        <input onChange={this.handleNameChange} value={this.state.name} type="text" className="form-control" id="task_name" readOnly={this.props.taskEditing.closed}/>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="task_description" className="col-sm-4 control-label">Task public description:</label>
                                    <div className="col-sm-8">
                                        <textarea
                                            value={this.state.description ? this.state.description : ""}
                                            onChange={this.handleDescriptionChange}
                                            className="no-horizontal-resize form-control"
                                            id="task-description"
                                            readOnly={this.props.taskEditing.closed}
                                            maxLength={1024}
                                            rows={5}
                                            style={{ resize: "vertical" }}
                                            />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="task_description" className="col-sm-4 control-label">Task private description:</label>
                                    <div className="col-sm-8">
                                        <textarea
                                            value={this.state.privateDescription ? this.state.privateDescription : ""}
                                            onChange={this.handlePrivateDescriptionChange}
                                            className="no-horizontal-resize form-control"
                                            id="task-description"
                                            readOnly={this.props.taskEditing.closed}
                                            maxLength={1024}
                                            rows={5}
                                            style={{ resize: "vertical" }}
                                            />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="task_approver" className="col-sm-4 control-label">Task approver:</label>
                                    <div className="col-sm-8">
                                        <AutoUserInput
                                            bannedUserIDs={[]}
                                            enableClear
                                            forceInitialPopup={false}
                                            handleFunction={this.handleApproverClick}
                                            handleTextChange={this.handleApproverTextChange}
                                            keepAfterClick
                                            noFilter={false}
                                            readOnly={this.state.readOnly}
                                            ref="task_approver"
                                            text={this.props.approver ? this.props.approver.givenName + " " + this.props.approver.surname : ""}
                                            users={this.props.pmUsers}
                                            />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="task_description" className="col-sm-4 control-label">Task quota (h):</label>
                                    <div className="col-md-3">
                                        <input onChange={this.handleTaskQuotaChange} value={this.state.taskQuota} type="text" className="form-control" id="task_quota" readOnly={this.props.taskEditing.closed}/>
                                    </div>
                                    <label htmlFor="task_description" className="col-sm-2 control-label">Total hours logged:</label>
                                    <div className="col-md-3">
                                        <input
                                            style={{color: (this.state.taskQuota && this.state.taskQuota > 0 && this.state.taskQuota * 60 < totalRegularTimeSpent) ? "red" : "black"}}
                                            value={DurationFormatter.format(totalRegularTimeSpent)}
                                            type="text"
                                            className="form-control"
                                            id="task_quota_used"
                                            readOnly={true}
                                            />
                                    </div>
                                </div>
                                {/*<div className="form-group">
                                    <div className="col-sm-offset-4 col-sm-8">
                                        <div className="checkbox">
                                            <label><input type="checkbox" disabled={this.props.taskEditing.closed}/> Billable</label>
                                        </div>
                                    </div>
                                </div>*/}
                                <br/>
                                <div className="form-group">
                                    <label className="col-md-4 control-label">People:</label>
                                    <div className="col-md-8">
                                        <table className="table table-condensed project-people">
                                            <thead>
                                                <tr>
                                                    <th>Name</th>
                                                    <th className="text-center">User Quota</th>
                                                    <th className="text-center">Hours logged</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tfoot>
                                                <tr>
                                                </tr>
                                            </tfoot>
                                            <tbody>
                                                {
                                                    this.state.userTasksAssigned.map((userTask, i) => {
                                                        return <UserPill
                                                                    active={userTask.active}
                                                                    assignedOn={userTask.assignedOn}
                                                                    closed={this.props.taskEditing.closed}
                                                                    editingQuota={this.state.editingOldQuotas[i]}
                                                                    handleRemove={this.handleRemoveUser}
                                                                    handleSaveQuota={this.handleOldQuotaChange}
                                                                    handleSetQuotaClick={this.handleOldQuotaClick}
                                                                    id={i}
                                                                    key={i}
                                                                    overtimeTimeSpent={userTask.overtimeTimeSpent}
                                                                    quota={userTask.quota}
                                                                    ref={"old" + i}
                                                                    regularTimeSpent={userTask.regularTimeSpent}
                                                                    text={userTask.usersName}
                                                                    userTask={userTask}
                                                                    showQuotaHistory
                                                                   />;
                                                    })
                                                }
                                                {
                                                    this.state.newlyAssigned.map((user, i) => {
                                                        return <UserPill
                                                                    active={user.active}
                                                                    assignedOn={user.assignedOn}
                                                                    closed={this.props.taskEditing.closed}
                                                                    editingQuota={this.state.editingNewQuotas[i]}
                                                                    handleSaveQuota={this.handleNewQuotaChange}
                                                                    handleSetQuotaClick={this.handleNewQuotaClick}
                                                                    handleRemove={this.handleRemoveNewUser}
                                                                    id={i}
                                                                    key={i}
                                                                    overtimeTimeSpent={user.overtimeTimeSpent}
                                                                    quota={user.quota}
                                                                    ref={"new" + i}
                                                                    regularTimeSpent={user.regularTimeSpent}
                                                                    text={user.givenName + ' ' + user.surname}
                                                                   />;
                                                    })
                                                }
                                                {
                                                    this.state.usersNoLongerAssigned.map((userNoLongerAssigned, i) => {
                                                        return <UserPill
                                                                    active={userNoLongerAssigned.active}
                                                                    handleReassign={this.handleReassignUser}
                                                                    id={i}
                                                                    key={i}
                                                                    noLongerAssigned={true}
                                                                    overtimeTimeSpent={userNoLongerAssigned.overtimeTimeSpent}
                                                                    ref={"noLongerAssigned" + i}
                                                                    regularTimeSpent={userNoLongerAssigned.regularTimeSpent}
                                                                    text={userNoLongerAssigned.givenName + ' ' + userNoLongerAssigned.surname }
                                                                    user={userNoLongerAssigned}
                                                                   />;
                                                    })
                                                }
                                            </tbody>
                                            <tfoot>
                                                <tr className="task-person-new">
                                                    <td></td>
                                                    <td className="text-center"><h5><strong>Σ</strong> {totalQuota / 60} h</h5></td>
                                                    <td className="text-center"><h5><strong>Σ</strong> {DurationFormatter.format(totalRegularTimeSpent)} (+ {DurationFormatter.format(totalOvertimeTimeSpent)})</h5></td>
                                                    <td></td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                </div>
                                {
                                    this.props.taskEditing.closed
                                    ? null
                                    : (
                                        <div>
                                        <label className="col-md-4 control-label">Add new:</label>
                                        <div className="col-md-8">
                                            <div className={this.state.newUserError ? "col-md-7 has-error" : "col-md-7"}>
                                                <div>
                                                    <AutoUserInput
                                                        bannedUserIDs={bannedUserIDs}
                                                        forceInitialPopup={false}
                                                        handleTextChange={this.handleUserTextChange}
                                                        handleFunction={this.handleUserSelected}
                                                        hideInactive
                                                        id={this.state.userTasksAssigned.length + this.state.newlyAssigned.length}
                                                        key={this.state.userTasksAssigned.length + this.state.newlyAssigned.length}
                                                        keepAfterClick
                                                        placeholder="Name"
                                                        popoverScale={2.05}
                                                        ref="userInput"
                                                        users={this.props.regularUsers}
                                                        />
                                                </div>
                                            </div>
                                            <div className={this.state.quotaError ? "col-md-3 has-error" : "col-md-3"}>
                                                <input value={this.state.currentQuota} onChange={this.handleUserQuotaChange} type="text" className="form-control" id="project-person-hours" placeholder="Quota"/>
                                            </div>
                                            {
                                                this.state.quotaError || this.state.newUserError
                                                ? <div className="col-md-2"></div>
                                                : <div style={{"marginLeft" : "5px"}} className="col-md-1 md-offset-1">
                                                    <button title="Add user to task" onClick={this.handleAddUser} style={{"background" : "transparent" , "border" : "none"}}>
                                                        <a className="icon-btn">
                                                            <span>
                                                                <span className="md-done"></span>
                                                            </span>
                                                        </a>
                                                    </button>
                                                  </div>
                                            }
                                        </div>
                                        </div>
                                    )
                                }
                              <div className="form-group">
                                <label className="col-md-4 col-sm-5 control-label">Billable:</label>
                                <div className="col-lg-6 col-md-7 col-sm-7" style={{"marginTop": "7px"}}>
                                  <input disabled={this.state.projectType !== "STANDARD"} type="checkbox" onChange={this.handleBillableChange} checked={this.state.billable}/>
                                </div>
                              </div>
                            </div>
                            <div className="panel-footer">
                                {
                                    this.props.deletable && !this.props.taskEditing.closed
                                    ?  <button title="Delete task" type="button" onClick={this.handleDeleteTask} className="btn btn-default btn-discrete btn-danger" data-dismiss="modal">Delete</button>
                                    : null
                                }
                                {
                                    this.state.readOnly ? null :
                                    this.props.taskEditing.closed
                                    ? <button title="Reopen task" type="button" className="btn btn-default btn-discrete" data-dismiss="modal" onClick={this.handleReopen}>Reopen</button>
                                    : <button title="Close task" type="button" className="btn btn-default btn-discrete" data-dismiss="modal" onClick={this.handleClose}>Mark as Closed</button>
                                }
                                {
                                    this.props.taskEditing.closed
                                    ? null
                                    : (<button title="Save changes" type="button" onClick={this.handleSaveTask} style={{backgroundColor : this.props.color}} className="btn btn-default btn-primary">Update</button>)
                                }
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
                    <form className="form-horizontal">
                    <div className="panel panel-default panel-pmtask">
                        <div className="panel-heading" role="tab" id="headingOne">
                            <h4 style={{wordWrap : "break-word"}} className="panel-title">
                            <a onClick={this.handleClick} style={{"cursor" : "pointer"}} data-toggle="collapse" aria-expanded="true" aria-controls="collapseOne">
                                <span className="md-chevron-right"></span>
                                {
                                    this.props.taskEditing.closed
                                    ? <s style={{textTransform: "none"}}>{this.props.name}</s>
                                    : <span style={{textTransform: "none"}}>{this.props.name}</span>
                                }
                            </a>
                            </h4>
                        </div>
                    </div>
                    </form>
                </div>
            );
        }
    }
}

EditTaskWidget.propTypes = {
    active: PropTypes.bool,
    allUsers: PropTypes.array,
    approver: PropTypes.object,
    approverName: PropTypes.string,
    color: PropTypes.string,
    currentUser: PropTypes.object,
    description: PropTypes.string,
    dispatch: PropTypes.func,
    handleAssign: PropTypes.func,
    handleClose: PropTypes.func,
    handleClick: PropTypes.func,
    handleDelete: PropTypes.func,
    handleReopen: PropTypes.func,
    handleSave: PropTypes.func,
    handleUnassign: PropTypes.func,
    taskId: PropTypes.number,
    name: PropTypes.string,
    pmUsers: PropTypes.array,
    project: PropTypes.object,
    privateDescription: PropTypes.string,
    regularUsers: PropTypes.array,
    selectedUser: PropTypes.object,
    taskEditing: PropTypes.object,
    taskNames: PropTypes.array,
    taskQuota: PropTypes.number,
    userTasksAssigned: PropTypes.array,
    usersAssigned: PropTypes.array,
    usersNoLongerAssigned: PropTypes.array
};

EditTaskWidget.defaultProps = {
    active: false,
    approver: null,
    approverName: "",
    description: "",
    taskId: null,
    name: "",
    privateDescription: "",
    usersAssigned: [],
    userTasksAssigned: [],
    usersNoLongerAssigned: []
};

const mapStateToProps = (state) => {
    return {
        allUsers: state.users.allUsers,
        currentUser: state.users.currentUser,
        pmUsers: state.users.pms.users,
        regularUsers: state.users.regularUsers,
        selectedUser: state.users.selectedUser,
        deletable: state.tasks.deletable,
        usersNoLongerAssigned: state.users.usersNoLongerAssigned,
        userTasksAssigned: state.userTasks.userTasks,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EditTaskWidget);



/** WEBPACK FOOTER **
 ** ./src/app/components/EditTaskWidget.js
 **/